import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedAdminRoute({ children, userType }) {
  if (userType !== "super_admin" && userType !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedAdminRoute;
